import React from "react";
import { View, StyleSheet, Text } from "@react-pdf/renderer";
import { config } from "./common/config";
import LogoFull from "./Logo-full";

const styles = StyleSheet.create({
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    position: "absolute",
    fontSize: 10,
    top: 15,
    left: 50,
    right: 50,
    textAlign: "left",
    color: "#444444",
    fontFamily: config.fontFamily,
    height: 50,
  },
  image: {
    width: "-100%",
    marginLeft: -10,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "space-between",
    height: "100%",
  },
  title: {
    fontWeight: "bold",
    fontSize: 15,
    color: "#000000",
  },
});

const Header = ({ relatory }) => (
  <View style={styles.header} fixed>
    <LogoFull />
    <View style={styles.info}>
      <Text style={styles.title}>{relatory.flow?.title}</Text>
      <Text>{relatory.flow?.client}</Text>
      <Text>
        Iniciado em:{" "}
        {new Date(relatory.flow?.createdAt).toLocaleString("pt-BR", {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}
      </Text>
    </View>
  </View>
);

export default Header;
